import { useMemo } from 'react';
import useSWRImmutable from 'swr/immutable';
import useEnv from 'hooks/useEnv';
import { fetcher } from 'services/fetcher';
import { getFormattedFlowAttributeDefinition } from 'services/formatter';
import { getMerchActionProducts } from 'services/merchandising';
import { MAX_PRODUCTS_PopinAjoutProduit } from 'settings/merchandising';
import { FormattedFlowAttributeType } from 'types/formatter';
import { PanierPopin } from 'types/PanierPopin';
import { ProductDetail } from 'types/Controls/ProductSheet';
import { ProductType } from 'types/ProductPageV2/Products';

type ReturnType = {
  attributes: FormattedFlowAttributeType;
  merchProducts: ProductDetail[];
};

export default function useAddToCartMerch(product: ProductType): ReturnType {
  const { urlApiCatalog } = useEnv();
  const { HierarchyId: categoryId, Id: productId } = product;
  const uri = `${urlApiCatalog}/json/Custom/PanierPopin.cxml?HierarchyId=${categoryId}&ProductId=${productId}`;
  const { data } = useSWRImmutable<PanierPopin>(uri, fetcher);

  return useMemo(() => {
    return {
      attributes: getFormattedFlowAttributeDefinition(
        data?.Header?.Controls[1]?.Attributes
      ),
      merchProducts: getMerchActionProducts(
        data?.Zones[0]?.Controls[0]?.Actions,
        MAX_PRODUCTS_PopinAjoutProduit
      ),
    };
  }, [data]);
}
